import axios from "axios";
import { ACCESS_TOKEN_KEY } from "../features/auth/store/login/reducer";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      window.location.replace("/login");
    }

    if (status === 403) {
      window.location.replace("/unauthorized");
    }

    console.error("Axios error:", {
      message: error.message,
      response: error.response,
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers,
    });

    return Promise.reject(error);
  },
);

export default axiosClient;
